import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import Loading from '../../ions/Loading';
import LegalCaseForm from './shared/LegalCaseForm';
import useLegalCasePageEditForm from '../../../hooks/useLegalCasePageEditForm';

interface LegalCaseListContext {
    refresh: () => void;
}

const LegalCasePageEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    // A edição agora é uma rota de página (não mais Outlet da lista). O contexto pode não
    // existir; o optional chaining cobre. Fechar volta para o detalhe do caso.
    const context = useOutletContext<LegalCaseListContext | undefined>();

    const handleClose = () => navigate(`/recovery/legal-cases/${id}`);

    const handleSuccess = () => {
        toast.success('Caso jurídico atualizado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useLegalCasePageEditForm({ uuid: id || '', onClose: handleClose, onSaved: handleSuccess });

    return (
        <Dialog
            id="legal-case-edit"
            show={true}
            onClose={handleClose}
            header="Editar Caso Jurídico"
            size="lg"
            body={form.isLoading ? <div className="p-8"><Loading /></div> : <LegalCaseForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating || form.isLoading}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            }
        />
    );
};

export default LegalCasePageEdit;
